<template>
  <div class="login">
    <div class="login-title">
      <img src="@/assets/images/logintitle.png" alt="" />
    </div>

    <div class="login-form">
      <div class="login-fotm-title">忘记密码</div>
      <div class="accountLogin">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="demo-ruleForm"
        >
          <el-form-item prop="organ_name">
            <div class="inputBox">
              <div class="inputTitle">
                <i class="iconfont icon-shehuizuzhiguanli"></i> 社会组织名称：
              </div>
              <el-input
                v-model="ruleForm.organ_name"
                placeholder="请输入您注册填写的社会组织名称"
                type="text"
                class="input"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item prop="username">
            <div class="inputBox">
              <div class="inputTitle">
                <i class="iconfont icon-zhanghao1"></i> 用户名：
              </div>
              <el-input
                v-model="ruleForm.username"
                placeholder="请输入用户名"
                type="text"
                class="input"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item prop="phone">
            <div class="inputBox">
              <div class="inputTitle">
                <i class="iconfont icon-shouji"></i> 手机号码：
              </div>
              <el-input
                v-model="ruleForm.phone"
                placeholder="请输入手机号码"
                type="text"
                class="input"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item prop="phone_code">
            <div class="inputBox">
              <div class="inputTitle">
                <i class="iconfont icon-yanzhengma1"></i> 手机验证码：
              </div>
              <el-input
                v-model="ruleForm.phone_code"
                placeholder="请输入手机验证码"
                type="text"
                class="input"
              >
              </el-input>
              <span v-show="show" @click="getPhoneCode()">获取验证码</span>
              <span class="gray" v-show="!show">{{ count }}s</span>
            </div>
          </el-form-item>
          <el-form-item prop="pass">
            <div class="inputBox">
              <div class="inputTitle">
                <i class="iconfont icon-zhanghaoanquan"></i> 密码：
              </div>
              <el-input
                v-model="ruleForm.pass"
                placeholder="请输入密码"
                type="password"
                class="input"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <div class="inputBox">
              <div class="inputTitle">
                <i class="iconfont icon-zhanghaoanquan"></i> 确认密码：
              </div>
              <el-input
                v-model="ruleForm.password"
                placeholder="请再次输入密码"
                type="password"
                class="input"
              >
              </el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="form-btn">
        <div class="btn" @click="register('ruleForm')">确定</div>
      </div>
      <div class="login-tex">
        <span @click="to('/orglogin')"
          >立即登录 <i class="iconfont icon-jiantouyou"></i
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { forgetPassword, getPhoneCode, verify } from "@/api/login";
import rules from "@/utils/rules";
export default {
  name: "register",
  data() {
    let validatePassSame = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      key: "",
      codeSrc: "",
      show: true, // 60秒倒计时
      count: "",
      timer: null,
      ruleForm: {
        organ_name: "",
        username: "",
        phone: "",
        phone_code: "",
        pass: "",
        password: "",
      },
      rules: {
        organ_name: [
          {
            required: true,
            message: "请输入您注册填写的社会组织名称",
            trigger: "blur",
          },
        ],
        username: [
          { required: true, message: "请输入您的用户名称", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          rules.phone,
        ],
        phone_code: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },
        ],
        pass: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 20, message: "密码格式为6-20位", trigger: "blur" },
        ],
        password: [{ validator: validatePassSame, trigger: "blur" }],
      },
    };
  },
  components: {},
  computed: {
    // phone() {
    //   return this.$store.state.phone
    // },
  },
  mounted() {},
  created() {
    this.getCode();
  },
  methods: {
    register(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.registerSub();
        } else {
          this.$message.error("请检查是否填写完整");
          return false;
        }
      });
    },

    // 获取手机号验证码
    async getPhoneCode() {
      this.$refs.ruleForm.validateField("phone", async (valid) => {
        if (!valid && this.show) {
          const loading = this.$loading({
            lock: true,
            text: "正在发送...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let _data = await getPhoneCode(this.ruleForm.phone);
          loading.close();
          if (_data.code == 200) {
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            this.$message.error(_data.message);
          }
        }
      });
    },

    // 获取图片验证码
    async getCode() {
      let _res = await verify();
      if (_res.code === 200) {
        this.codeSrc = _res.data.captcha;
        this.key = _res.data.key;
      } else {
        this.$message.error(_res.message);
      }
    },

    // 立即注册
    async registerSub() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let _res = await forgetPassword(
        this.ruleForm.organ_name,
        this.ruleForm.username,
        this.ruleForm.phone,
        this.ruleForm.phone_code,
        this.ruleForm.password
      );
      if (_res.code === 200) {
        loading.close();
        this.$message.success(_res.message);
        this.$router.replace("/orglogin");
      } else {
        loading.close();
        this.$message.error(_res.message);
      }
    },

    // 跳转
    to(path) {
      this.$router.replace(path);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-input__inner {
    border: none;
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
  }
}
.login {
  width: 100%;
  height: 100vh;
  background: url("../../assets/images/loginbgc.jpg") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;

  .login-form {
    width: 800px;
    height: 710px;
    background-color: rgba(255, 255, 255, 0.7);
    box-shadow: 0px 20px 24px 0px rgba(3, 37, 143, 0.7);
    border-radius: 20px;
    position: relative;
    margin: 0 auto;
    margin-top: 60px;
    padding-top: 50px;
    .login-tex {
      width: 100%;
      padding-top: 20px;
      padding-right: 40px;
      display: flex;
      justify-content: flex-end;
      span {
        font-size: 14px;
        color: #064fb5;
        cursor: pointer;
        i {
          font-size: 16px;
          color: #064fb5;
          font-weight: bold;
        }
      }
    }

    .form-btn {
      width: 100%;
      display: flex;
      justify-content: center;
      .btn {
        width: 264px;
        height: 58px;
        background-color: #064fb5;
        border-radius: 29px;
        text-align: center;
        line-height: 58px;
        font-size: 18px;
        letter-spacing: 2px;
        color: #ffffff;
        font-weight: bold;
        cursor: pointer;
      }
    }

    .accountLogin {
      width: 100%;
      padding: 50px 90px;
      padding-bottom: 25px;

      .inputBox {
        width: 100%;
        height: 54px;
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 25px;

        span {
          font-size: 14px;
          color: #064fb5;
          cursor: pointer;
          margin-left: 20px;
          &.gray {
            color: #b2b2b2;
          }
        }

        .yzmimg {
          width: 92px;
          height: 40px;
          margin-left: 30px;
          img {
            width: 100%;
            height: 100%;
          }
        }

        .inputTitle {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 16px;
          color: #333333;
          i {
            font-size: 20px;
            color: #ccd9ec;
            margin-right: 10px;
          }
        }

        .input {
          flex: 1;
        }
      }
    }

    .login-fotm-title {
      width: 327px;
      height: 54px;
      background: url("../../assets/images/form-title.png") no-repeat;
      background-size: 100% 100%;
      text-align: center;
      line-height: 54px;
      font-size: 24px;
      letter-spacing: 2px;
      color: #ffffff;
      position: absolute;
      top: -4px;
      left: 50%;
      margin-left: -163px;
    }
  }

  .login-title {
    width: 100%;

    img {
      width: 749px;
      height: auto;
      display: block;
      margin: 0 auto;
    }
  }
}
</style>
